import { dom } from './dom.js';
import { state } from './state.js';
import { UI } from './ui.js';
import { Utils } from './utils.js';
import { TreeRenderer } from './tree-renderer.js';

export const Parser = {
  parse() {
    const raw = dom.inputArea.value.trim();

    if (!raw) {
      state.lastParsed = null;
      UI.showError();
      UI.renderEmptyState('Nothing to parse.');
      Utils.setStatusBadge(dom.outputBadge, '—');
      Utils.setStatusBadge(dom.inputBadge, 'JSON');
      return;
    }

    try {
      const parsed = JSON.parse(raw);
      Parser.handleSuccess(parsed, '✓ Valid', 'Valid JSON');
    } catch (error) {
      Parser.handleError(error.message);
    }
  },

  evalInput() {
    const raw = dom.inputArea.value.trim();
    if (!raw) {
      Parser.parse();
      return;
    }

    try {
      const parsed = new Function(`return (${raw})`)();
      state.lastParsed = parsed;
      UI.showError();
      TreeRenderer.render(parsed);
      Utils.setStatusBadge(dom.outputBadge, '✓ Eval OK', 'ok');
    } catch (error) {
      Parser.handleError(`Eval error: ${error.message}`);
    }
  },

  format() {
    try {
      dom.inputArea.value = JSON.stringify(JSON.parse(dom.inputArea.value), null, 2);
      Parser.parse();
    } catch (error) {
      UI.showError(error.message);
    }
  },

  minify() {
    try {
      dom.inputArea.value = JSON.stringify(JSON.parse(dom.inputArea.value));
      Parser.parse();
    } catch (error) {
      UI.showError(error.message);
    }
  },

  handleSuccess(parsed, outputText, inputText) {
    state.lastParsed = parsed;
    UI.showError();
    TreeRenderer.render(parsed);
    Utils.setStatusBadge(dom.outputBadge, outputText, 'ok');
    Utils.setStatusBadge(dom.inputBadge, inputText, 'ok');
  },

  handleError(message) {
    state.lastParsed = null;
    UI.showError(message);
    UI.renderEmptyState(`⚠ ${message}`, true);
    Utils.setStatusBadge(dom.outputBadge, '✗ Error', 'err');
    Utils.setStatusBadge(dom.inputBadge, 'Error', 'err');
  },
};
